import axios from 'axios';
import {
  CircularProgress, Backdrop, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TablePagination, TableRow, FormControl, InputLabel, Select,
  Grid, Container, Button, Typography, IconButton, Collapse, Box, TextField
} from '@material-ui/core';
import { Form, Modal } from 'react-bootstrap';
import React, { PureComponent } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { getAPIUrl } from '../../helpers/CommonHelper';
import moment from 'moment';
import { KeyboardArrowDown, KeyboardArrowUp, Edit } from '@material-ui/icons';
import '../../styles/OrderComponent.css';

function Row(props) {
  const { row, type } = props;
  const [showExpandedRow, setShowExpandedRow] = React.useState(false);
  return(
    <React.Fragment>
      <TableRow>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setShowExpandedRow(!showExpandedRow)}>
            {showExpandedRow ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell align="center" style={{ minWidth: 100, maxWidth: 100, wordBreak: 'break-all' }}>
          {row.trackingNumber}
        </TableCell>
        <TableCell align="center" style={{ maxWidth: 50 }}>
          {row.orderStatus}
        </TableCell>
        <TableCell align="center" style={{ minWidth: 100 }}>
          {row.customerId}
        </TableCell>
        {
          type !== 'pending' && 
          <TableCell align="center" style={{ minWidth: 100 }}>
            {row.driverId}
          </TableCell>
        }
        <TableCell align="center" style={{ minWidth: 100 }}>
          {row.pickupTime && moment(row.pickupTime).format('MM-DD-YYYY, h:mm a')}
        </TableCell>
        <TableCell align="center" style={{ minWidth: 100 }}>
          {row.dropTime && moment(row.dropTime).format('MM-DD-YYYY, h:mm a')}
        </TableCell>
        <TableCell align="center" style={{ minWidth: 100 }}>
          <IconButton aria-label="edit order" size="small" onClick={() => props.editPopup(row)}>
            <Edit />
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={8}>
          <Collapse in={showExpandedRow} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Pickup Address</TableCell>
                    <TableCell align="center">Drop Address</TableCell>
                    {type === 'completed' && <TableCell align="center">Delivery Date</TableCell>}
                    <TableCell align="center">Quote price</TableCell>
                    {type !== 'pending' && <TableCell align="center">Driver Cost</TableCell>}
                    <TableCell align="center">Miles</TableCell>
                    <TableCell align="center">Remarks</TableCell>
                    <TableCell align="center">Transaction Details</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell align="center" style={{ minWidth: 150 }}>
                      {row.pickupAddress}
                    </TableCell>
                    <TableCell align="center" style={{ minWidth: 150 }}>
                      {row.dropAddress}
                    </TableCell>
                    {
                      type === 'completed' &&
                      <TableCell align="center" style={{ minWidth: 100 }}>
                        {moment(row.deliveryDateTime).format('MM-DD-YYYY, h:mm a')}
                      </TableCell>
                    }
                    <TableCell align="center" style={{ minWidth: 100 }}>
                      ${row.quotePrice}
                    </TableCell>
                    {
                      type !== 'pending' && 
                      <TableCell align="center" style={{ minWidth: 100 }}>
                        ${row.driverCost}
                      </TableCell>
                    }
                    <TableCell align="center" style={{ maxWidth: 50 }}>
                      {row.deliveryMiles}
                    </TableCell>
                    <TableCell align="center" style={{ maxWidth: 50 }}>
                      {row.remarks}
                    </TableCell>
                    <TableCell align="center" style={{ minWidth: 100, maxWidth: 200 }}>
                      {
                        row.transactionDetails.map((item) => {
                          return (
                            <div key={item.transactionType}>
                              <p>
                                <b>{item.transactionType}</b>&nbsp;
                                ID: {item.transactionId},
                                Date: {moment(item.transactionDateTime).format('MM-DD-YYYY, h:mm a')},
                                Amount: ${item.transactionAmount}
                              </p>
                            </div>
                          );
                        })
                      }
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  )
}

class OrderComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      showExpandedRow: false,
      page: 0,
      order: [],
      type: 'pending',
      rowsPerPage: 10,
      totalItem: 0,
      showEditOrderModal: false,
      selected: {
        orderStatus: 'Driver Accept',
        remarks: '',
        pickupAddress: '',
        dropAddress: '',
        driverId: '',
        driverCost: '',
        dropSign: '',
        dropPhoto: '',
        pickupTime: new Date(),
        dropTime: new Date(),
      }
    };
  }

  componentDidMount() {
    this.fetchOrderDetails();
  }

  fetchOrderDetails = () => {
    this.setState({
      isLoading: true
    });
    axios.get(`${getAPIUrl()}/admin/order/all?type=${this.state.type}`, {
      timeout: 30000,
      headers: {
        'Authorization': this.props.token
      }
    }).then((resp) => {
      this.setState({
        isLoading: false,
        order: resp.data.data,
        totalItem: resp.data.totalItem ? resp.data.totalItem : 0
      });
    }).catch((error) => {
      console.error(error);
      this.setState({
        isLoading: false,
      });
      if (error.response && error.response.status === 401) {
        alert('Session expired!! Please login again');
        this.props.logout();
      } else {
        alert('Something went wrong!!!');
      }
    });
  }

  updateOrderDetail = () => {
    this.setState({
      showEditOrderModal: false,
      isLoading: true
    });
    const { selected } = this.state;
    axios.put(`${getAPIUrl()}/admin/order/${selected.orderId}`, {
      orderStatus: selected.orderStatus,
      driverEmail: selected.driverId,
      driverCost: parseInt(selected.driverCost, 10),
      remarks: selected.remarks
    } , {
      timeout: 30000,
      headers: {
        'Authorization': this.props.token
      }
    }).then(() => {
      this.fetchOrderDetails();
    }).catch((error) => {
      console.error(error);
      this.setState({
        isLoading: false,
      });
      if (error.response && error.response.status === 401) {
        alert('Session expired!! Please login again');
        this.props.logout();
      } else {
        alert('Something went wrong!!!');
      }
    });
  }

  inputChanged = (value, key) => {
    this.setState({
      selected: {
        ...this.state.selected,
        [key]: value,
      }
    });
  }

  pickupDateChange = (event) => {
    this.setState({
      selected: {
        ...this.state.selected,
        pickupTime: event,
      }
    });
  }

  dropDateChange = (event) => {
    this.setState({
      selected: {
        ...this.state.selected,
        dropTime: event,
      }
    });
  }

  handleChangePage = (event, newPage) => {
    this.setState({
      page: newPage
    });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0
    });
  }

  filterOrderChange = (event) => {
    this.setState({
      type: event.target.value
    }, () => {
      this.fetchOrderDetails();
    });
  }

  changeOrderStatus = (event) => {
    this.setState({
      selected: {
        ...this.state.selected,
        orderStatus: event.target.value
      }
    });
  }

  handleEditOrderModalShow = (row) => {
    this.setState({
      showEditOrderModal: true,
      selected: {
        orderStatus: row.orderStatus === 'Waiting for driver' ? 'Driver Accept' : row.orderStatus,
        orderId: row.orderId,
        dropPhoto: row.dropPhoto,
        dropSign: row.dropSign,
        remarks: row.remarks,
        pickupAddress: row.pickupAddress,
        dropAddress: row.dropAddress,
        driverId: row.driverId,
        driverCost: row.driverCost,
        pickupTime: row.pickupTime,
        dropTime: row.dropTime
      }
    });
  }

  // handleAddOrderModalShow = () => {
  //   this.setState({
  //     addNewOrderModal: true
  //   });
  // }

  handleModalClose = () => {
    this.setState({
      showEditOrderModal: false,
      // addNewOrderModal: false,
    });
  }

  render() {
    return (
      <Paper className="table-container">
        <FormControl className="select-container">
          <InputLabel htmlFor="demo-customized-select-native">Order Status</InputLabel>
          <Select
            native
            value={this.state.type}
            onChange={this.filterOrderChange}
            inputProps={{
              name: 'Order Status',
              id: 'order-status-native-simple',
            }}
          >
            <option value="pending">Pending</option>
            <option value="confirmed">Confirmed</option>
            <option value="completed">Completed</option>
          </Select>
        </FormControl>
        {/* <Button color="primary" variant="contained" onClick={this.handleAddOrderModalShow} className="new-order-button">
          Add Order
        </Button> */}
        <TableContainer className="container">
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell align="center">Order Ref</TableCell>
                <TableCell align="center">Order Status</TableCell>
                <TableCell align="center">Customer</TableCell>
                {this.state.type !== 'pending' && <TableCell align="center">Driver</TableCell>}
                <TableCell align="center">Pickup Date</TableCell>
                <TableCell align="center">Drop Date</TableCell>
                <TableCell align="center">Edit</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.order.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((row) => {
                return (
                  <Row row={row} editPopup={this.handleEditOrderModalShow} key={row.orderId} type={this.state.type} />
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={this.state.totalItem}
          rowsPerPage={this.state.rowsPerPage}
          page={this.state.page}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
          onChangePage={this.handleChangePage}
        />
        <Backdrop className="loading-indicator" open={this.state.isLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Modal show={this.state.showEditOrderModal} onHide={this.handleModalClose}>
          <Modal.Body>
            <Container>
              <Grid item xs={12} sm={12} md={12}>
                <Form>
                  <FormControl className="select-container">
                    <InputLabel htmlFor="demo-customized-select-native">Order Status</InputLabel>
                    <Select
                      native
                      value={this.state.selected.orderStatus}
                      onChange={this.changeOrderStatus}
                      inputProps={{
                        name: 'Order Status',
                        id: 'order-status-native-simple',
                      }}
                    >
                      <option value="Driver Accept">Driver Accept</option>
                      <option value="No driver available">No driver available</option>
                      <option value="Parcel picked-up">Package picked-up</option>
                      <option value="Parcel dropped">Package dropped</option>
                      <option value="Customer cancelled">Customer cancelled</option>
                      <option value="Admin cancelled">Admin cancelled</option>
                    </Select>
                  </FormControl>
                  <Form.Group>
                    <TextField
                      label="Pickup Address"
                      onChange={(event) => this.inputChanged(event.target.value, 'pickupAddress')}
                      value={this.state.selected.pickupAddress}
                      variant="outlined"
                      size="small"
                      required
                    />
                  </Form.Group>
                  <Form.Group>
                    <TextField
                      label="Drop Address"
                      onChange={(event) => this.inputChanged(event.target.value, 'dropAddress')}
                      value={this.state.selected.dropAddress}
                      variant="outlined"
                      size="small"
                      required
                    />
                  </Form.Group>
                  <Form.Group>
                    <TextField
                      label="Driver Email"
                      onChange={(event) => this.inputChanged(event.target.value, 'driverId')}
                      value={this.state.selected.driverId}
                      variant="outlined"
                      size="small"
                      required
                    />
                  </Form.Group>
                  <Form.Group>
                    <TextField
                      label="Driver Cost"
                      onChange={(event) => this.inputChanged(event.target.value, 'driverCost')}
                      value={this.state.selected.driverCost}
                      variant="outlined"
                      size="small"
                      required
                    />
                  </Form.Group>
                  <Form.Group>
                    <TextField
                      label="Remarks"
                      onChange={(event) => this.inputChanged(event.target.value, 'remarks')}
                      value={this.state.selected.remarks}
                      variant="outlined"
                      size="small"
                      required
                    />
                  </Form.Group>
                  <Form.Group>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DateTimePicker
                        variant="inline"
                        label="Pickup time"
                        value={this.state.selected.pickupTime}
                        minutesStep={15}
                        onChange={this.pickupDateChange}
                      />
                    </MuiPickersUtilsProvider>
                  </Form.Group>
                  <Form.Group>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DateTimePicker
                        variant="inline"
                        label="Drop time"
                        value={this.state.selected.dropTime}
                        minutesStep={15}
                        onChange={this.dropDateChange}
                      />
                    </MuiPickersUtilsProvider>
                  </Form.Group>
                  {
                    this.state.selected.dropPhoto !== '' && 
                    <Form.Group>
                      <Typography variant="h6" gutterBottom>
                        Drop photo
                      </Typography>
                      <img src={this.state.selected.dropPhoto} height={300} width={300} />
                    </Form.Group>
                  }
                  {
                    this.state.selected.dropSign !== '' && 
                    <Form.Group>
                      <Typography variant="h6" gutterBottom>
                        Drop Signature
                      </Typography>
                      <img src={this.state.selected.dropSign} height={300} width={300} />
                    </Form.Group>
                  }
                </Form>
              </Grid>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button color="primary" disableElevation onClick={this.updateOrderDetail}>Save</Button>
            <Button disableElevation onClick={this.handleModalClose}>Close</Button>
          </Modal.Footer>
        </Modal>
      </Paper>
    )
  }
}

export default OrderComponent;
